module.exports = __webpack_public_path__ + "img/pink1.18ded59f.png";